import React from 'react';
import { IconBase } from '../Base';
export const IconVND = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("g", { clipPath: "url(#clip0_2_9391)" },
        React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#D80027" }),
        React.createElement("path", { d: "M12 6.26086L13.2951 10.2466H17.4859L14.0954 12.7099L15.3905 16.6957L12 14.2323L8.60952 16.6957L9.90458 12.7099L6.51411 10.2466H10.7049L12 6.26086Z", fill: "#FFDA44" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_9391" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=VND.js.map